import React, { useContext } from 'react';

import cx from 'classnames';
import { isNil } from 'ramda';
import { useHistory } from 'react-router';

import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { transformBEScheduleToOverviewForm } from 'store/itineraryDetails/transform';
import { confirmAlert } from 'utils/alert';
import { getDateFormat } from 'utils/date';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

import s from './index.module.css';

export const ListItem = ({ item, itemClass }) => {
  return (
    <div className={cx(s.item, itemClass, 'custom-overview-item')} data-block>
      <div className={cx(s.itemTitle, 'custom-overview-item-title')}>{item?.formattedRange}</div>
      <div className={cx(s.itemDesc, 'custom-overview-item-desc')}>{item?.detailsText}</div>
      <div className={cx(s.itemDesc, 'custom-overview-item-desc')}>{item?.accommodationText}</div>
      <div className={cx(s.itemDesc, 'custom-overview-item-desc')}>{item?.formattedNumberOfNights}</div>
    </div>
  );
};

export const List = ({ collection }) => collection.map((item, i) => <ListItem key={i} item={item} />);

function Overview() {
  const history = useHistory();
  const itinerariesItemContext = useItinerariesItemContext();
  const isInsideItinerariesItemBuilder = !isNil(itinerariesItemContext);
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.ITINERARY);
  const { page, readOnly } = useContext(LandingPageContext);
  const schedules = page?.schedules;
  const scheduleType = page?.scheduleType;
  const collection = transformBEScheduleToOverviewForm(scheduleType, schedules, {
    includeOnlyDifferentYears: true,
    translate: true,
    translationFormat: '%B %-d',
    translationDateFormat: getDateFormat(page?.settings?.displayDatesDdMmYyyy),
  });

  const handleClick = () => {
    if (readOnly || !isInsideItinerariesItemBuilder) return;

    confirmAlert({
      title: (
        <>
          Edits to this page can only be done in the Details Tab. <br /> Do you want to go there now?
        </>
      ),
      confirmButtonText: 'Go to Details Tab',
      onConfirm: () => {
        history.push(getStepPath(ITINERARY_STEPS.DETAILS, itinerariesItemContext.itemId));
      },
    });
  };

  return (
    <div className={cx(s.wrapper, 'custom-overview-wrapper')} onClick={handleClick}>
      <List collection={collection} />
    </div>
  );
}

export default Overview;
